//import EVENTS     from '../../constants/common_events.constants';

export class SplashController {

    constructor($interval, $state, SaasDao,$scope) {
this.$scope = $scope
        this.SaasDao = SaasDao;
        this.$interval = $interval;
        this.$state = $state;
        this.checkSaas()
        $scope.$on('$destroy', () => {
            if (this.isLongPooling === true) {
                this.cancelLongPooling();
            }
        });
    }

    checkSaas() {

        this.SaasDao.get().$promise.then((data) => {

            console.log("The Saas Status is", data);
            if (data.is_saas_service && !data.is_completed) {

                this.hidden = true;
                this.poolSaasStatus();
            }

        });
    }

    poolSaasStatus() {

        this.isLongPooling = true;
        this.longPooling = this.$interval(() => {
            this.checkSaasStatus();
        }, 10000);
    }

    cancelLongPooling() {
        //console.log('stopping long pooling!');
        this.$interval.cancel(this.longPooling);
        this.isLongPooling = false;
    }

    checkSaasStatus() {

        this.SaasDao.get().$promise.then((data) => {
            if (data.is_completed) {
                this.cancelLongPooling();
                this.$state.go('home');
            }
        });
    }

}



// WEBPACK FOOTER //
// ./modules/xray/states/splash/splash.controller.js